module.exports = __webpack_public_path__ + "img/class.69432815.png";